import { Button, styled } from "@mui/material";

// Same as StyledSecondaryGreyMini but with special disabled style
const StyledDisabledSecondaryGreyMini = styled(Button)(({ theme }) => ({
  paddingRight: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  backgroundColor: theme.palette.common.white,
  color: theme.palette.secondary.dark,
  "&:hover": {
    backgroundColor: theme.palette.common.white,
  },
  border: `1px solid ${theme.palette.secondary.dark}`,
  boxShadow: "none",
  "&:disabled": {
    color: theme.palette.secondary.dark,
    border: `1px solid ${theme.palette.secondary.dark}`,
  },
}));

export default StyledDisabledSecondaryGreyMini;
